import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";
import { fadeIn } from "../../../../../styles/animations";
import shades from "../../../../../styles/shadesPalette";

export const TableInstance = styled.table`
  width: 1600px;
  height: 600px;
  border-spacing: 0;
  box-sizing: border-box;
  background: transparent;
  overflow: hidden;
  box-shadow: ${shades.shadow3};
  @media (max-width: 1366px) {
    width: 1087px;
    height: 500px;
  }
`;

export const THead = styled.thead`
  position: sticky;
  align-items: center;
  height: 40px;
  text-align: center;
  background: ${colors.gray2};
`;

export const TRHead = styled.tr`
  padding-top: 5px;
  font-size: 10px;
  text-align: left;
  color: ${colors.gray3};
  box-sizing: border-box;
  & > * {
    max-width: 120px;
    &:nth-child(1) {
      display: none;
    }
    &:nth-child(2) {
      max-width: 760px;
    }
  }
  @media (max-width: 1400px) {
    & > * {
      max-width: 80px;
    }
  }
`;

export const THHead = styled.th`
  position: sticky;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-y: auto;
  background: transparent;
`;

export const Scroll = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  height: 510px;
  color: #1e1e1e;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  background: ${colors.white1};
  &::-webkit-scrollbar {
    background: ${colors.white1};
    width: 0.5em;
    height: 0.5em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.grayScroll};
    border-radius: 4px;
  }
  @media (max-width: 1400px) {
    width: 1100px;
    height: 274px;
  }
`;

export const TBody = styled.tbody`
  width: 100%;
  height: 100%;
  color: #1e1e1e;
  background: transparent;
`;

export const TRBody = styled.tr`
  align-items: center;
  font-size: 14.5px;
  color: #1e1e1e;
  &:hover {
    background: #edf2f7;
  }
`;

export const TDBody = styled.td`
  white-space: nowrap;
  color: #1e1e1e;
  text-overflow: ellipsis;
`;

export const TR = styled.tr`
  height: ${(props) => (props.isExpanded ? "80px" : "50px")};
  color: #1e1e1e;
  border-bottom: ${(props) => (props.isExpanded ? null : `1px solid ${colors.gray2}`)};
  text-align: center;
  vertical-align: bottom;
  overflow: hidden;
  animation: 1s ${fadeIn} forwards;
  &:hover {
    transition: all 0.4s;
    background: ${(props) => (props.isExpanded ? null : "#edf2f7")};
  }
  & > * {
    max-width: 120px;
    height: 300px;
    &:nth-child(1) {
      display: none;
    }
    &:nth-child(2) {
      max-width: 760px;
    }
  }
  @media (max-width: 1366px) {
    height: ${(props) => (props.isExpanded ? "70px" : "40px")};
    & > * {
      max-width: 80px;
      &:nth-child(2) {
        max-width: 511px;
      }
    }
  }
`;

export const TD = styled.td`
  height: ${(props) => (props.isExpanded ? "80px" : "50px")};
  @media (max-width: 1366px) {
    height: ${(props) => (props.isExpanded ? "70px" : "40px")};
  }
`;

export const TDSub = styled.td`
  height: 50px;
`;

export const Span = styled.span`
  height: 2px;
`;

export const Text = styled.div`
  margin-left: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => (props.isExpanded ? colors.orange1 : colors.gray6)};
  font-family: "OpenSansRegular";
  font-size: 18px;
  transition: 0.5s font-variation-settings ease-in;
  font-weight: ${(props) => (props.isExpanded || props.mark ? 700 : 400)};
  opacity: ${(props) => (props.isSelected || props.canExpand ? 1 : 0.5)};
  @media (max-width: 1400px) {
    font-size: 14px;
  }
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 120px;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 12px;
  font-weight: 400;
  color: ${colors.gray5};
  @media (max-width: 1400px) {
    width: 80px;
    font-size: 10px;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transparent;
  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;
